import axios from "axios";
import {kc} from './security-keycloak';

const url = process.env.VUE_APP_BASE_URL_API;

const instance = axios.create({
    baseURL : url,
    timeout: 60000,
    headers: {
        "Content-type": "application/json; charset=UTF-8"
    }
});

instance.interceptors.request.use(async (config) => {
    const token = kc.token()

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    return config
})

export default instance;
